import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// Uses the same Highcharts integration as the GeoTracking dashboard.
// Values are passed by the caller; the chart does not collect security data.
export default function SecurityActivityChart({ categories, values, title, type = 'column' }: { categories: string[]; values: number[]; title: string; type?: 'column' | 'pie' }) {
  const options: Highcharts.Options = {
    chart: { type, height: 240, backgroundColor: 'transparent', style: { fontFamily: 'inherit' } },
    title: { text: undefined },
    credits: { enabled: false },
    legend: { enabled: false },
    xAxis: { categories, labels: { style: { color: 'currentColor' } }, lineColor: '#939aa3' },
    yAxis: {
      min: 0, allowDecimals: false,
      title: { text: title, style: { color: 'currentColor' } },
      labels: { style: { color: 'currentColor' } },
      gridLineColor: 'rgba(127,127,127,0.18)',
    },
    tooltip: { headerFormat: '<b>{point.key}</b><br/>', pointFormat: '{series.name}: <b>{point.y}</b>' },
    plotOptions: { column: { borderWidth: 0, maxPointWidth: 32 }, pie: { innerSize: '55%', borderWidth: 0, dataLabels: { enabled: true, format: '{point.name}: {point.y}', style: { color: 'currentColor', textOutline: 'none' } } }, series: { animation: false } },
    series: type === 'pie'
      ? [{ type: 'pie', name: title, data: categories.map((name, index) => ({ name, y: values[index], color: ['#ff7b2c', '#cf5740', '#9c7728'][index % 3] })) }]
      : [{ type: 'column', name: title, color: '#ff7b2c', data: values }],
  };
  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
